var _defs, _rect, _circle, _rect2, _polygon, _rect3, _polygon2, _rect4, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.83 23.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#696969;stroke-miterlimit:10;}.cls-1{stroke-width:1px;}.cls-2{stroke-width:0.86px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 10.55,
    height: 10.55,
    rx: 1.33
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5.78,
    cy: 5.78,
    r: 3.27
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 12.78,
    width: 10.55,
    height: 10.55,
    rx: 1.33
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.78 15.11 6.75 17.08 8.93 17.39 7.35 18.93 7.72 21.1 5.78 20.07 3.83 21.1 4.2 18.93 2.63 17.39 4.8 17.08 5.78 15.11"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.78,
    y: 0.5,
    width: 10.55,
    height: 10.55,
    rx: 1.33
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.27 8.61 14.84 8.61 18.04 3.13 21.27 8.61"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.78,
    y: 12.78,
    width: 10.55,
    height: 10.55,
    rx: 1.33
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "18.05 14.97 14.76 17.36 16.02 21.24 20.09 21.24 21.35 17.36 18.05 14.97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipartIcon);
export default __webpack_public_path__ + "static/media/clipart_icon.b6e8b7825d14bbf3358c43fec6f2fbec.svg";
export { ForwardRef as ReactComponent };